import { render, staticRenderFns } from "./down.vue?vue&type=template&id=15fd0267&scoped=true&"
import script from "./down.vue?vue&type=script&lang=js&"
export * from "./down.vue?vue&type=script&lang=js&"
import style0 from "./down.vue?vue&type=style&index=0&id=15fd0267&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd0267",
  null
  
)

export default component.exports